import { GET, POST, PUT, DELETE } from './core';

export const getEndpointWithPrefix = (endpoint) => {
  return `/user/${endpoint}`;
};

export const getAllUserDetails = (token) => {
  const endpoint = getEndpointWithPrefix('');
  return GET(endpoint, token);
};

export const getAllUsersPaged = (token, page = 0, size = 25) => {
  const endpoint = `/user?page=${page}&size=${size}`;
  return GET(endpoint, token);
};

export const filterUser = (token, data) => {
  const endpoint = getEndpointWithPrefix('filter');
  return POST(endpoint, data, token);
};

export const addUser = (token, data) => {
  const endpoint = '/authentication/register-administrator';
  return POST(endpoint, data, token);
};

export const getAllAdmins = (token, currentPage, pageSize) => {
  const endpoint = `/admin?page=${currentPage}&pageSize=${pageSize}`;
  return GET(endpoint, token);
};

export const updateUserDetails = (token, data) => {
  const endpoint = '/admin/update';
  return PUT(endpoint, data, token);
};

export const deleteUserDetails = (token, id) => {
  const endpoint = `/admin/delete/${id}`;
  return DELETE(endpoint, {}, token);
};

export const updateUserMobileNumber = (token, data) => {
  const endpoint = getEndpointWithPrefix('update');
  return PUT(endpoint, data, token);
};